@use '@/sass/variables';

.DurationSelect {
  width: 170px;
}

// Error styling following project patterns - matches SearchSelect approach
:global(.duration-picker__error) {
  :global(.ui__select__control) {
    border: 2px solid variables.$red !important;
  }
}
